import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";
import HRBudgeting from "../../../images/services/cto/HR-Budgeting.svg";
import HumanCapitalManagement from "../../../images/services/cto/Human-Capital-Management.svg";
import PerformanceManagementAnalytics from "../../../images/services/cto/Performance-Management-Analytics.svg";
import Recruitmentonboarding from "../../../images/services/cto/Recruitment-onboarding.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Techsolution(props) {
    return (
        <div className="p-100 tekrevol_gray_bg">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={7} xxl={7}>
                        <div className="example" data-text="HR Solutions">
                            <h2>HR Solutions For Diverse Objectives</h2>
                        </div>
                    </Col>
                </Row>
                <Row className="tech_bg">
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tech_tabs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={HRBudgeting}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    HR Budgeting
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Businesses have two specific options for deploying the financial side of human
                                        resources. Firstly, you can build and deploy a fully integrated system, with
                                        finances and budgeting as a feature. Secondly, you can create a fully-featured
                                        system dedicated to the financial management of HR. This includes monthly and
                                        periodic payment systems, payroll calculation and processing, HR budgeting and
                                        future financial forecasts, and compensation management.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={HumanCapitalManagement}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Capital Management
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol can build a turnkey human capital management system that helps employers
                                        keep a pulse of the resource infrastructure of their organization. In this
                                        panel, businesses can create resource-related goals, plan their learning and
                                        development, track the impact of new training, and evaluate areas that need
                                        improvement. These panels also help manage work and productivity for businesses
                                        practicing hybrid and remote / work-from-anywhere arrangements.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={PerformanceManagementAnalytics}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Performance Management
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>This area is dedicated to internal and external data collection and works around
                                        performance metrics and KPIs (Key Performance Indicators). Businesses preferably
                                        tag this panel with their organizations' project and task management programs to
                                        automate the calculation and evaluation of periodic workflow and growth.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={Recruitmentonboarding}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Recruitment & Onboarding
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>This panel helps with hiring and adding new employees to the database. Dedicated
                                        personnel can send out interview invitations, update the status of applications,
                                        record results of recruitment and onboarding functions, and store documents
                                        required at the time of onboarding.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Techsolution;